<div class="product-container">
  <a class="button-ghost" [routerLink]="['./', rowItem.id]"
    ><span>{{ rowItem.name }}</span
    ><clr-icon shape="arrow right"
  /></a>
</div>